import { getTourData } from 'aria-viewer/analytics/utils/analyticUtils'
import { trackEvent } from 'aria-viewer/core/middleware/analyticsMiddleware'
import * as EVENTS from 'aria-viewer/analytics/constants'
import { PANORAMA_DRAG_END, PANORAMA_MOUSE_WHEEL } from '../actions/panoramaActions'

const panoPlayerAnalytics = {
    [PANORAMA_DRAG_END]: (getState, action) => {
        const { inst_name, owner_id, loc_name, loc_id, stoptitle, stopid } = getTourData()(getState)

        return trackEvent(EVENTS.SCENE_PANS, {
            Institution: inst_name,
            Inst_ID: owner_id,
            Location: loc_name,
            Loc_ID: loc_id,
            Stop: stoptitle,
            Stop_ID: stopid,
        })
    },

    [PANORAMA_MOUSE_WHEEL]: (getState, action) => {
        const { inst_name, owner_id, loc_name, loc_id, stoptitle, stopid } = getTourData()(getState)

        return trackEvent(EVENTS.PANORAMA_ZOOM, {
            Institution: inst_name,
            Inst_ID: owner_id,
            Location: loc_name,
            Loc_ID: loc_id,
            Stop: stoptitle,
            Stop_ID: stopid,
        })
    },
}

export default panoPlayerAnalytics
